import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {}
  }

  @action async GetUserInfoWeb(uid) {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d && d.res
    }
  }

  // 列表记录
  @action async getMonopolyGift() {
    let res = await http.post('/web/ruby/act/gift')
    return res
  }

  @action async getMonopolyRank({ week, type }) {
    let res = await http.post('/web/ruby/act/rank', { week, type })
    return res
  }
  @action async GetServerTime(map) {
    let d = await http.post('/web/ServerTimeAr', map)
    if (d.code == 0) {
      return d.res
    }
  }
}



// WEBPACK FOOTER //
// src/store/app/monopoly.js